import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/storage";
require("@/assets/gobo-app.scss");
// Import Duet Date Picker
import { defineCustomElements } from "@duetds/date-picker/dist/loader";
import * as VueGoogleMaps from "gmap-vue";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import Hotjar from "vue-hotjar";
import InputFacade from "vue-input-facade";
import { isAllowedEmail } from "@/utils/deprecation";

Vue.use(VueCroppie);
Vue.use(VueQuillEditor, { toolbar: ["bold", "italic"] });
Vue.use(InputFacade);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBxt7GTz4w74LxqVtx31Ert13X1EmG3hhk",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'gmap-vue/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
});

// ...
// configure Vue.js to ignore Duet Date Picker
Vue.config.ignoredElements = [/duet-\w*/];

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBxt7GTz4w74LxqVtx31Ert13X1EmG3hhk",
    libraries: "places",
    map_id: "a7f1aa6c21b72aae"
  }
});

Vue.use(Hotjar, {
  id: "2418098",
  isProduction: true,
  snippetVersion: 6
});

// Register Duet Date Picker
defineCustomElements(window);

Vue.config.productionTip = false;

var app = "";

const configOptions = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain:
    process.env.VUE_APP_FIREBASE_AUTHDOMAIN ||
    process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL:
    process.env.VUE_APP_FIREBASE_DATABASEURL ||
    process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId:
    process.env.VUE_APP_FIREBASE_PROJECTID ||
    process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket:
    process.env.VUE_APP_STORAGE_BUCKET ||
    process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId:
    process.env.VUE_APP_FIREBASE_MESSAGING_SENDERID ||
    process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:
    process.env.VUE_APP_FIREBASE_APPID || process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId:
    process.env.VUE_APP_FIREBASE_MEASURMENTID ||
    process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

firebase.initializeApp(configOptions);
firebase.analytics();
firebase.storage();

Vue.prototype.$analytics = firebase.analytics();

// Set up browserLocalPersistence for cross-app authentication
const auth = firebase.auth();
auth
  .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .then(() => {
    console.log(
      "Firebase Auth persistence set to LOCAL for cross-app authentication"
    );
  })
  .catch(error => {
    console.error("Failed to set auth persistence:", error);
  });

auth.onAuthStateChanged(async user => {
  // This app is deprecated: only the accounts in ALLOWED_EMAILS may stay signed
  // in here. Enforced at the auth state rather than on the login forms because
  // there are four sign-in paths in this codebase (the store actions, AuthView,
  // and the older login/signup components) and this is the one they all pass
  // through -- including any added later. Checked before the profile is
  // fetched, so a blocked account never loads anybody's data.
  const blocked = user && !isAllowedEmail(user.email);
  if (blocked) {
    console.log("Deprecated app: signing out " + user.email);
    // Raise the notice again, so a blocked login is explained rather than
    // silently bouncing back to a login form.
    store.commit("SHOW_DEPRECATION");
    try {
      await auth.signOut();
    } catch (error) {
      // Still fall through: the notice is up and the profile is not loaded.
      console.error("Deprecated app: sign out failed", error);
    }
  }

  await store.dispatch("fetchUser", blocked ? null : user);
  if (user && user.uid && !blocked) {
    Bugsnag.setUser(user.uid, user.email, user.displayName);
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});

Bugsnag.start({
  apiKey: "c2a4564b5e77590df1f82d66f2e0b61f",
  plugins: [new BugsnagPluginVue()],
  releaseStage: process.env.NODE_ENV,
  appVersion: "1.1"
});
const bugsnagVue = Bugsnag.getPlugin("vue");
bugsnagVue.installVueErrorHandler(Vue);
